import Axios from "axios";
import { message } from "antd";
import db from "../../../database";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { getOAuthHeaders } from "../../../constants/oAuthValidation";

export const createCustomer = async (data, cart, setCart, form, tillLayout, closeCustomerSearch, tillData, posLogActivity, setKioskUI, setDisplayAddNewCustomer) => {
  let setAuthTokens;
  const authHeaders = await getOAuthHeaders();
  if (authHeaders && authHeaders.access_token) {
    setAuthTokens = authHeaders.access_token;
  }
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const serverUrl = process.env.REACT_APP_serverUrl;
  const newCustomerId = uuidv4().replace(/-/g, "").toUpperCase();
  const newRequest = {
    query: `mutation {
        upsertB2CCustomer(
          id: "${newCustomerId}"
          type: "New"
          customer: {
            csBunitId: "${tillData.tillAccess.csBunit.csBunitId}",
            createdby: "${tillData.tillAccess.csUserId}",
            updatedby: "${tillData.tillAccess.csUserId}",
            code: ${data.mobile ? `"${data.mobile.toLowerCase()}"` : null},
            name: ${data.name ? `"${data.name}"` : null},
            mobileNo: ${data.mobile ? `"${data.mobile}"` : null},
            email: ${data.email ? `"${data.email}"` : null},
            pincode: ${data.pincode ? data.pincode : null},
            sCustomerId: "${tillData.tillAccess.csBunit.b2cCustomer.sCustomer.sCustomerID}",
            finPaymentmethodId: null,
            retlLoyaltyBalance: null,
            iscredit: false,
            b2cRegisteredstoreId: "${tillData.tillAccess.csBunit.csBunitId}",
            firstName: "${data.name}",
            lastName: ${data.lastName ? `"${data.lastName}"` : null},
            gender: ${data.gender !== "" && data.gender !== undefined ? `"${data.gender}"` : null},
            taxId: ${data.taxID ? `"${data.taxID}"` : null},
            anniversaryDate: ${data.anniversaryDate !== undefined && data.anniversaryDate !== null ? `"${moment(data.anniversaryDate).format("YYYY-MM-DD")}"` : null},
            birthday: ${data.BirthdayDate !== undefined && data.BirthdayDate !== null ? `"${moment(data.BirthdayDate).format("YYYY-MM-DD")}"` : null},
            lastVisitDate: ${data.lastVisitDate !== undefined && data.lastVisitDate !== null ? `"${moment(data.lastVisitDate).format("YYYY-MM-DD")}"` : null},
            noOfVisits: 0,
            lastBillingAmount: 0,
            averageBasketValue: 0,
            loyaltyPointToExpire: null,
            loyaltyLevel: { cwrLoyaltyLevelId:  ${posConfig.addLoyaltyLevel === "Y" && posConfig.loyaltyLevelID !== null ? `"${posConfig.loyaltyLevelID}"` : null} }
            customerAddress: {
              line1: ${data.street ? `"${data.street}"` : null},
              line2: ${data.city ? `"${data.city}"` : null},
              city: ${data.city ? `"${data.city}"` : null},
              csRegionId: ${tillData.tillAccess.csBunit.customerAddress.csRegion.csRegionID ? `"${tillData.tillAccess.csBunit.customerAddress.csRegion.csRegionID}"` : null},
              csCountryId: ${tillData.tillAccess.csBunit.customerAddress.csCountry.csCountryID ? `"${tillData.tillAccess.csBunit.customerAddress.csCountry.csCountryID}"` : null},
            }            
          }
        ) {
          cwrCustomerId
          code
          name
          email
          mobileNo
          pincode
          retlLoyaltyBalance
          b2cRegisteredstoreId
          lastVisitDate
          noOfVisits
          lastBillingAmount
          averageBasketValue
          loyaltyPointToExpire
          firstName
          lastName
          gender
          taxId
          anniversaryDate
          birthday
          sCustomer {
            sCustomerID
            customerCategory {
              sCustomerCateforyId
              value
              name
              description
            }
          }
          csBunit {
            csBunitId
            name
          }
          customerAddress {
            line1
            line2
            city
            region
            country
            csCountryId
            csRegionId
          }
          status
          message
        }
      }`,

  };
  Axios({
    url: serverUrl,
    method: "POST",
    data: newRequest,
    headers: {
      "Content-Type": "Application/json",
      Authorization: `${setAuthTokens}`,
    },
  })
    .then((response) => {
      const result = response.data.data.upsertB2CCustomer;
      if (result.status === "200") {
        if (tillLayout === 3) {
          localStorage.setItem("kioskUI", 3);
          setKioskUI(3);
          const customEvent = new CustomEvent("customStorageChange", {
            detail: { key: "kioskUI", newValue: 3 },
          });
          window.dispatchEvent(customEvent);
        }
        form.resetFields();
        setDisplayAddNewCustomer(false);
        setCart({
          ...cart,
          customer: result,
        });
        closeCustomerSearch();
        message.success(result.message);
        if (
          db.logConfiguration.toArray().then((fetched) => {
            fetched.map((item) => {
              item.addCustomer.filter((item) => item.log === "Y").length > 0;
            });
          })
        ) {
          posLogActivity(result.name, "ACT");
        }
      } else {
        message.error("Some thing went wrong try again later !");
      }
    })
    .catch((error) => {
      console.error("Adding a new customer failed: ", error);
      message.error("Some thing went wrong try again later !");
    });
};

export const updateCustomer = async (data, cart, setCart, form, closeCustomerSearch, selectedEditOldCustomer, setSelectedEditOldCustomer, setDisplayEditOldCustomer, tillData) => {
  let setAuthTokens;
  const authHeaders = await getOAuthHeaders();
  if (authHeaders && authHeaders.access_token) {
    setAuthTokens = authHeaders.access_token;
  }
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const serverUrl = process.env.REACT_APP_serverUrl;
  const newRequest = {
    query: `mutation{
              upsertB2CCustomer(id: "${selectedEditOldCustomer.cwrCustomerId}", 
                type:"Old",
                customer: {
                  csBunitId: "${tillData.tillAccess.csBunit.csBunitId}",
                  createdby: "${tillData.tillAccess.csUserId}",
                  updatedby: "${tillData.tillAccess.csUserId}",
                  code: "${data.editMobile}"
                  name: "${data.editName}"
                  mobileNo: "${data.editMobile}"
                  email: ${data.editEmail ? `"${data.editEmail}"` : null},
                  pincode: ${data.editPincode ? data.editPincode : null},
                  sCustomerId: "${tillData.tillAccess.csBunit.b2cCustomer.sCustomer.sCustomerID}",
                  finPaymentmethodId: null,
                  retlLoyaltyBalance: null,
                  iscredit: false,
                  b2cRegisteredstoreId: "${tillData.tillAccess.csBunit.csBunitId}",
                  firstName: "${data.name}",
                  lastName: ${data.lastName ? `"${data.lastName}"` : null},
                  gender: ${data.gender !== "" && data.gender !== undefined ? `"${data.gender}"` : null},
                  taxId: ${data.taxID ? `"${data.taxID}"` : null},
                  anniversaryDate: ${(data.anniversaryDate !== undefined && data.anniversaryDate !== null) ? `"${moment(data.anniversaryDate).format("YYYY-MM-DD")}"` : null},
                  birthday: ${(data.BirthdayDate !== undefined && data.BirthdayDate !== null) ? `"${moment(data.BirthdayDate).format("YYYY-MM-DD")}"` : null},
                  lastVisitDate: ${(data.lastVisitDate !== undefined && data.lastVisitDate !== null) ? `"${moment(data.lastVisitDate).format("YYYY-MM-DD")}"` : null},
                  noOfVisits: 0,
                  lastBillingAmount: 0,
                  averageBasketValue: 0,
                  loyaltyPointToExpire: null,
                  loyaltyLevel: { cwrLoyaltyLevelId:  ${posConfig.addLoyaltyLevel === "Y" && posConfig.loyaltyLevelID !== null ? `"${posConfig.loyaltyLevelID}"` : null} }
                  customerAddress: {
                    line1: ${data.street ? `"${data.street}"` : null},
                    line2: ${data.city ? `"${data.city}"` : null},
                    city: ${data.city ? `"${data.city}"` : null},
                    csRegionId: ${tillData.tillAccess.csBunit.customerAddress.csRegion.csRegionID ? `"${tillData.tillAccess.csBunit.customerAddress.csRegion.csRegionID}"` : null},
                    csCountryId: ${tillData.tillAccess.csBunit.customerAddress.csCountry.csCountryID ? `"${tillData.tillAccess.csBunit.customerAddress.csCountry.csCountryID}"` : null},
                  }            
                }){
                cwrCustomerId
                code
                name
                email
                mobileNo
                pincode
                retlLoyaltyBalance
                b2cRegisteredstoreId
                lastVisitDate
                noOfVisits
                lastBillingAmount
                averageBasketValue
                loyaltyPointToExpire
                firstName
                lastName
                gender
                taxId
                anniversaryDate
                birthday
                sCustomer {
                  sCustomerID
                  customerCategory {
                    sCustomerCateforyId
                    value
                    name
                    description
                  }
                }
                csBunit {
                  csBunitId
                  name
                }
                customerAddress {
                  line1
                  line2
                  city
                  region
                  country
                  csCountryId
                  csRegionId
                }
                status
                message
              }
            }`,
  };
  Axios({
    url: serverUrl,
    method: "POST",
    data: newRequest,
    headers: {
      "Content-Type": "Application/json",
      Authorization: `${setAuthTokens}`,
    },
  })
    .then((response) => {
      const result = response.data.data.upsertB2CCustomer;
      if (result.status === "200") {
        form.resetFields();
        setSelectedEditOldCustomer();
        setDisplayEditOldCustomer(false);
        setCart({
          ...cart,
          customer: result,
        });
        closeCustomerSearch();
        message.success(result.message);
      } else {
        message.error("Some thing went wrong try again later !");
      }
    })
    .catch((error) => {
      console.error("Updating customer failed: ", error);
      message.error("Some thing went wrong try again later !");
    });
};

export const getCustomer = async (form, tillLayout, customerSearchInput, setKioskUI, setCustomerSearchResults, kioskLogin) => {
  let setAuthTokens;
  const authHeaders = await getOAuthHeaders();
  if (authHeaders && authHeaders.access_token) {
    setAuthTokens = authHeaders.access_token;
  }
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const serverUrl = process.env.REACT_APP_serverUrl;
  let query;
  let validation;
  let loginType;
  if (tillLayout !== 3) {
    if (
      !/^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/.test(customerSearchInput) &&
      !RegExp("^[6-9][0-9]{9}$")?.test(parseFloat(customerSearchInput)) &&
      !parseFloat(customerSearchInput)
    ) {
      validation = RegExp("^[0-9a-zA-Z]{1,20}$");
      loginType = "name";
    }
  }

  if (/^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/.test(customerSearchInput)) {
    loginType = "email";
  }

  if (/^[1-9]\d*$/.test(customerSearchInput)) {
    loginType = "mobile";
  }


    const paramsInput = {
      query: `query{
          customerSearch(searchKey:"${customerSearchInput.toLowerCase()}"){
            cwrCustomerId 
            code   
            name
            email        
            mobileNo
            name
            pincode
            retlLoyaltyBalance
            b2cRegisteredstoreId
             iscredit
             lastVisitDate
             noOfVisits
             lastBillingAmount
             averageBasketValue
             loyaltyPointToExpire
             firstName
              lastName
               gender
                taxId
            anniversaryDate
             birthday
            loyaltyLevel{
                cwrLoyaltyLevelId
                name
                accumulationRate
                redemptionRate
            }
            sCustomer{
              sCustomerID
              customerCategory{
                sCustomerCateforyId
                value
                name
                description
              }
            }
            customerAddress {
                line1 
                line2 
                city 
                region
                 country 
                 csCountryId
                  csRegionId
            }
            csBunit{
              csBunitId
              name
            }
            b2cCustomerSegment{
              name
              cwrB2CCustomerSegmentId
            }
          }
        }`,
    };
    Axios({
      url: serverUrl,
      method: "POST",
      data: paramsInput,
      headers: {
        "Content-Type": "Application/json",
        Authorization: `${setAuthTokens}`,
      },
    })
      .then((response) => {
        localStorage.setItem("loginType", loginType);
        if (response.data.data.customerSearch.length > 0) {
          const result = response.data.data.customerSearch;
          if (tillLayout === 3) {
            kioskLogin.resetFields();
            setKioskUI(3);
            const customEvent = new CustomEvent("customStorageChange", {
              detail: { key: "kioskUI", newValue: 3 },
            });
            window.dispatchEvent(customEvent);
            localStorage.setItem("kioskUI", 3);
          }
          setCustomerSearchResults(result);
        } else {
          console.warn("No customer found, try searching with different customer");
          if (tillLayout === 3) {
            form.setFieldsValue({
              [loginType]: customerSearchInput,
            });
            localStorage.setItem("kioskUI", 4);
            setKioskUI(4);
            const customEvent = new CustomEvent("customStorageChange", {
              detail: { key: "kioskUI", newValue: 4 },
            });
            window.dispatchEvent(customEvent);
          }
          setCustomerSearchResults([]);
        }
      })
};